<template>
  <div class="png1-bottom">
    <div class="mb-6" v-for="(block, ind) in blocks" :key="ind">
      <div class="png1-block__row">
        <div
          class="png1-block__item"
          v-for="(item, iInd) in block.blocks"
          :key="iInd"
        >
          <div class="png1-block__item-content">
            <div class="png1-block__item-title" v-html="item.title"></div>
            <input
              type="checkbox"
              :id="`png1_opener_${ind}_${iInd}`"
              v-if="item && item.tip"
            />
            <div
              class="png1-block__item-tip"
              v-if="item && item.tip"
              v-html="item.tip"
            ></div>
            <label
              :for="`png1_opener_${ind}_${iInd}`"
              v-if="item && item.tip"
              class="png1-block__item-button button button_small button_empty-pink d-inline-flex ml-auto"
            >
              <span class="open">Проверить себя</span>
              <span class="close">Cкрыть</span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.5 5.5L8.5 10.5L3.5 5.5"
                  stroke="#830051"
                  stroke-linecap="square"
                />
              </svg>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PNGDropdownFirst",
  computed: {
    blocks() {
      return [
        {
          blocks: [
            {
              title: "Что такое ПНГ?",
              tip: "ПНГ представляет собой прогрессирующее, жизнеугрожающее заболевание с хроническим неконтролируемым внутрисосудистым гемолизом, опосредованным комплементом, что сопровождается тромбозом, повреждением органов-мишеней и снижением качества жизни.",
            },
          ],
        },
        {
          blocks: [
            {
              title: "Чем вызывается ПНГ?",
              tip: "ПНГ вызывается соматической мутацией гена PIG-A, которая приводит к отсутствию ключевых белков-ингибиторов терминального этапа активации комплемента, в норме имеющихся на поверхности клеток.",
            },
          ],
        },
        {
          blocks: [
            {
              title: "Как связана ПНГ с ночью?",
              tip: "Термин пароксизмальная ночная гемоглобинурия ошибочен. При ПНГ гемолиз не носит ни пароксизмального, ни ночного характера, а продолжается даже при отсутствии симптомов. Кроме того, при первичном обследовании гемоглобинурия имеется у 62% пациентов с ПНГ. Однако у некоторых пациентов течение болезни может не сопровождаться гемоглобинурией.",
            },
          ],
        },
        {
          blocks: [
            {
              title: "Является ли ПНГ гемолитической анемией?",
              tip: "ПНГ не является гемолитической анемией. Однако анемия является симптомом ПНГ.",
            },
          ],
        },
        {
          blocks: [
            {
              title: "Перечислите исходные клинические проявления ПНГ",
              tip: "Исходные клинические проявления у пациентов с ПНГ могут включать утомляемость, анемию, гемоглобинурию, одышку, дистонию гладких мышц в виде дисфагии, боли в животе и эректильную дисфункцию.",
            },
          ],
        },
        {
          blocks: [
            {
              title: "На что могут указывать указанные сиптомы?",
              tip: "Эти часто наблюдаемые симптомы могут указывать на развитие угрожающих жизни осложнений, которые возникают у пациентов с ПНГ, таких как ВТЭ и артериальный тромбоз, инсульт, ХБП, острая почечная недостаточность, нарушение функции сердца и ЛГ.",
            },
          ],
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.png1-bottom {
  margin-top: 32px;
  &__title {
    padding: 8px 16px;
    background-color: #8a7098;
    color: #fff;
    text-align: center;
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }
}
.png1-block {
  &__row {
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 32px;

    @media screen and (max-width: 767px) {
      padding: 16px 0 0;
      grid-template-columns: 1fr;
      row-gap: 16px;
    }
  }

  &__item {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 72px;

    &-arrow {
      width: fit-content;
      margin: 0 auto;

      @media screen and (max-width: 767px) {
        display: none;
      }
    }

    &-content {
      position: relative;
      border: 1px solid #fff;
      padding: 24px;
      color: #3c4242;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      height: 100%;
    }

    &-title {
      font-weight: 500;
      @media screen and (max-width: 1199px) {
        max-width: 380px;
      }
    }

    &-tip {
      max-height: 0;
      transition: 0.3s;
      overflow: hidden;
    }

    & input {
      display: none;
    }

    & input {
      &:checked {
        & ~ .png1-block {
          &__item {
            &-tip {
              margin-top: 8px;
              max-height: 500px;
              margin-bottom: 40px;
              @media screen and (max-width: 767px) {
                margin-bottom: 0;
              }
            }
            &-button {
              margin-top: 16px;
              & .open {
                display: none;
              }
              & .close {
                display: block;
              }
              & svg {
                transform: rotate(-180deg);
              }
            }
          }
        }
      }
    }

    &-button {
      margin-top: auto;
      position: absolute;
      right: 24px;
      bottom: 24px;
      & .open {
        display: block;
      }
      & .close {
        display: none;
      }
      & svg {
        transform: rotate(0deg);
        transition: 0.3s;
        margin-left: 4px;
      }
      @media screen and (max-width: 767px) {
        margin-top: 16px;
        position: static;
      }
    }

    &:first-child {
      .png1-block {
        &__item {
          &-content {
            border-color: #b19fba;
          }
        }
      }
    }

    &:last-child {
      .png1-block {
        &__item {
          &-content {
            border-color: #d2d2d2;
            border-radius: 8px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.png1-block__item {
  & sup {
    color: inherit !important;
  }
}
</style>
